import React from "react";
import { useAppSettings } from "../../hooks/useAppSettings.tsx";
import Layout from "../../components/Layout.tsx";
import Title from "../../components/Title.tsx";
import TableRiesgoOperativo from "../../components/catalogo/Sucursales/riesgoOperativo/TableRiesgoOperativo.tsx";

const RiesgoOperativoPage = () => {
  useAppSettings();

  return (
    <Layout>
      <Title
        baseTitle="Riesgo Operativo"
        basePath="/riesgo-operativo"
        activeTitle="Riesgo Operativo"
        title="Riesgo Operativo"
      />
      <div className="m-4">
        <TableRiesgoOperativo />
      </div>
    </Layout>
  );
};

export default RiesgoOperativoPage;

